import { render, staticRenderFns } from "./typesetting4.vue?vue&type=template&id=18e92794&scoped=true&"
import script from "./typesetting4.vue?vue&type=script&lang=js&"
export * from "./typesetting4.vue?vue&type=script&lang=js&"
import style0 from "./typesetting4.vue?vue&type=style&index=0&id=18e92794&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e92794",
  null
  
)

export default component.exports